// extracted by mini-css-extract-plugin
export default {"avatar":"UserAvatar-module__avatar__2sqtv"};